import React from "react";

export default function KeyNotesSpeaker() {
  return (
    <div className="keynotes-main-frame">
      {/* <div className="top-margin">
        <div>
          <div style={{ transform: "(-50,50)", marginTop: "5rem" }}>
            <img src="./images/comming soon.png" width="60%" alt="Responsive" />
          </div>
        </div>
      </div> */}
      <div className="container">
        <div className="about">
          <div className="card border-primary mb-3">
            <div className="card-body">
              <h5 className="card-title text-primary">KEYNOTE SPEAKER 1</h5>
              <h6 className="card-subtitle mb-2 text-muted">&nbsp;</h6>
              <div
                style={{
                  margin: "1rem",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                }}
              >
                <div class="keynotes">
                  <div>
                    <img class="speakerImg" src="/images/john.png" alt=" " />
                  </div>
                  <p id="name">Dr. Jonathan M Cansino,</p>
                  <p>
                    Quality Assurance Head- EEE Section University of
                    Technology,
                  </p>
                  <p> Muscat.</p>
                  <br />
                  <p id="name">Topic : Lorawan and it's Applications</p>
                  <p>22.10.2021</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container">
        <div className="about">
          <div className="card border-primary mb-3">
            <div className="card-body">
              <h5 className="card-title text-primary">KEYNOTE SPEAKER 2</h5>
              <h6 className="card-subtitle mb-2 text-muted">&nbsp;</h6>
              <div
                style={{
                  margin: "1rem 1rem 2rem 1rem",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                }}
              >
                <div class="keynotes">
                  <div>
                    <img class="speakerImg" src="/images/Arul.jpeg" alt=" " />
                  </div>
                  <p id="name"> Mr.Arul, BE, MS.,</p>
                  <p> Adobe systems,</p>
                  <p> Silicon Valley,</p>
                  <p> USA.</p>
                  <br />
                  <p id="name">Topic : Cloud Systems</p>
                  <p>23.10.2021</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
